import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  businessTypeId: 0,
  packageId: 0,
  businessDetails: {
    businessName: "",
    designatorId: 1,
  },
  businessLocation: {
    street: "",
    city: "",
    state: "",
    zipcode: "",
  },
  primaryContact: {
    fullName: "",
    email: "",
  },
  businessCategoryId: 0,
  businessMembers: [
    {
      firstName: "",
      lastName: "", 
      email: "",
      ssnNumber: "",
      ownership: "",
    },
  ],
  operationAgreementId: null,
  licenseReportId: null,
  lzBookKeepingId: null,
  expeditedProcessId: undefined,
  foundersKitId: undefined,
  taxExpertId: undefined,
  scorpId: "",
  questionnaire: [
  ],

  totalAmount: {
    subTotal: 0,
    salesTax: 0,
    filingFee: 0,
    total: 0,
  },
};

export const businessSlice = createSlice({
  name: "business",
  initialState: initialState,
  reducers: {
    update_business_id: (state, action) => {
      state.businessTypeId = action.payload;
    },
    
    update_package_id: (state, action) => {
      state.packageId = action.payload;
    },
   
    update_business_state: (state, action) => {
      state.businessLocation.state = action.payload.state;
    },
    update_business_details: (state, action) => {
      state.businessDetails.businessName = action.payload.businessName;
      state.businessDetails.designatorId = action.payload.designatorId;
    },
    update_business_type: (state, action) => {
      state.businessCategoryId = action.payload;
    },
    update_business_location: (state, action) => {
      state.businessLocation.street = action.payload.street;
      state.businessLocation.city = action.payload.city;
      state.businessLocation.state = action.payload.state;
      state.businessLocation.zipcode = action.payload.zipcode;
    },
    update_business_members: (state, action) => {
      const businessMember = {
        firstName: action.payload.firstName,
        lastName: action.payload.lastName,
        email : action.payload.email,
        ownership:"default",
        ssnNumber:"default"
      }
      state.businessMembers = [businessMember]
    },
    update_business_members_corpo: (state, action) => {
      state.businessMembers = action.payload
    },
    update_busniness_primary_contact: (state, action) => {
      state.primaryContact.fullName = action.payload.fullName;
      state.primaryContact.email = action.payload.email;
    },
    update_business_agreement: (state, action) => {
      state.operationAgreementId = action.payload;
    },
    update_business_licence: (state, action) => {
      state.licenseReportId = action.payload;
    },
    add_expeditedProcessId: (state, action) => {
      state.expeditedProcessId = action.payload;
    },
    remove_expeditedProcessId: (state) => {
      delete state.expeditedProcessId;
    },
    add_foundersKitId: (state, action) => {
      state.foundersKitId = action.payload;
    },
    remove_foundersKitId: (state,action) => {
      delete state.foundersKitId; 
    },
    // add_payment: (state, action) => {
    //   state.expeditedProcessId = action.payload;
    // },
    // remove_payment: (state) => {
    //   state.expeditedProcessId = 0
    // },
    update_package_corp_id: (state,action ) => {
      state.scorpId = action.payload
    },
    update_question: (state, action) => {
      const { questionId, answerId } = action.payload;
      state.questionnaire = [...state.questionnaire.filter((item) => item.questionId != questionId),{ questionId, answerId }];
    },
   
    update_total_amount: (state, action) => {
      state.totalAmount = action.payload;
    },
    update_business_bookkeeping: (state, action) => {
      state.lzBookKeepingId = action.payload;
    },
    reset_state: (state) => {
      return initialState;
    },
  },
});

export const {
  reset_state,
  update_business_licence,
  update_business_id,
  update_business_state,
  update_total_amount,
  update_business_bookkeeping,
  update_package_id,
  update_business_details,
  update_business_type,
  update_business_location,
  update_business_members,
  update_business_members_corpo,
  update_busniness_primary_contact,
  update_business_agreement,
  add_expeditedProcessId,
  remove_expeditedProcessId,
  add_foundersKitId,
  remove_foundersKitId,
  update_package_corp_id,
  update_question,
} = businessSlice.actions;
export default businessSlice.reducer;

